import { Observable, observe, Scope } from 'wdc-cube'
import { WaitingScope } from '../../the-connection/tc_scopes'

export type UserGroupRow = {
    id: number
    name: string
    full_name: string
    can_export_data: boolean
}

export type LimitChangeRow = {
    seq: number
    group_id: number
    unlimited_data_export: boolean
    new_limit_export: number
    mes_ano: Date
    data_hora: Date
}

export type GroupRow = {
    id?: number
    name: string
    admin_id?: number
    admin_name?: string
    admin_fullname?: string
    limit_export_quantity?: number
    users?: UserGroupRow[]
    limitHistory?: LimitChangeRow[]
    deleted_date?: Date
    active?: boolean
    unlimited_data_export?: boolean
    block_export_when_exceeded?: boolean
    crm_enrichment_enabled?: boolean
    tcm_sb_active_filters: Record<string, boolean>
    tc_sb_active_filters: Record<string, boolean>
    ta_sb_active_filters: Record<string, boolean>
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class GroupManagerScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope
    @observe() groupFilter = ''

    @observe() groups = [] as GroupRow[]

    @observe() showDeleted = false
    @observe() deleteModalOpen = false
    @observe() groupToDelete?: GroupRow
    @observe() deleteConfirmText = ''

    @observe() rowMenuGroupId?: number

    onNew = Scope.ASYNC_ACTION
    onEdit = Scope.ASYNC_ACTION_NUMBER
    onShowProfile = Scope.ASYNC_ACTION_NUMBER
    onGroupFilterChanged = Scope.ASYNC_ACTION_STRING
    onFind = Scope.ASYNC_ACTION
    onClearFilters = Scope.ASYNC_ACTION
    onShowDeletedChange = Scope.ASYNC_ACTION
    onOpenRowMenu = Scope.ASYNC_ACTION_NUMBER
    onCloseRowMenu = Scope.ASYNC_ACTION
    onDeleteGroup = Scope.ASYNC_ACTION_NUMBER
    onDeleteConfirmTextChanged = Scope.ASYNC_ACTION_STRING
    onConfirmDeleteGroup = Scope.ASYNC_ACTION
    onCancelConfirmDeleteGroup = Scope.ASYNC_ACTION
}

export default GroupManagerScope
